export default __webpack_public_path__ + "static/media/http-versions.32d052de.png";